import styled from "styled-components";
import { Colors } from "../../config/Constants";

type Props = {
  totalText: string;
  totalCount: number;
  imageSrc: string;
};

export const DashboardTotalCard = ({
  totalText,
  totalCount,
  imageSrc,
}: Props) => {
  return (
    <TotalCardLayout>
      <div>
        <TotalType>{totalText}</TotalType>
        <TotalCount>{totalCount}</TotalCount>
      </div>
      <StyledImage>
        <img
          src={require(`../../assets/images/${imageSrc}.png`)}
          alt="total_img"
        />
      </StyledImage>
    </TotalCardLayout>
  );
};

const TotalCardLayout = styled.div`
  background-color: ${Colors.blackRussian};
  border-radius: 10px;
  width: 90%;
  min-height: 110px;
  height: auto;
  display: flex;
  justify-content: space-between;
  position: relative;
  &: last-child {
    width: 100%;
  }
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

const TotalType = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  letter-spacing: 0.44px;
  color: ${Colors.white};
  font-family: "Poppins-Book";
  padding-top: 1.25rem;
  padding-left: 1.875rem;
  @media only screen and (max-width: 1460px) {
    width: 7.5rem;
    padding-left: 1.25rem;
  }
`;

const TotalCount = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 2.125rem;
  color: ${Colors.white};
  font-family: "Poppins-Bold";
  padding-left: 1.875rem;
  padding-top: 0.3rem;
  @media only screen and (max-width: 1460px) {
    padding-left: 1.25rem;
  }
`;

const StyledImage = styled.div`
  transform: translate(-5px, 8px);
  position: absolute;
  right: 3px;
`;
